import { createI18n } from 'vue-i18n'

function loadLocaleMessages() {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    const messages = {}
    locales.keys().forEach(key => {
      // console.log('KEY', key)
      let keysPath = key.split('/');
      keysPath.pop();
      // console.log('END_KEY', endKey)
      const matched = key.match(/([A-Za-z0-9-_]+)\./i)
      // console.log('MATCHED', matched)
      if (matched && matched.length > 1) {
        const locale = matched[1]
        messages[locale] = messages[locale] !== undefined ? messages[locale] : {};
        recursivePath(messages[locale], keysPath, locales, key);
        let ppath = key.split('/');
        ppath.pop();
        ppath.shift();
        ppath = ppath.join('.');
        console.log('ppath', ppath)
        nestedVal.set(ppath, messages[locale], locales(key));
  
        // messages[locale] = locales(key).default
        // console.log('TST',tst) 
      }
    })
    // console.log('TST',tst) 
    return messages 
  }
  
  function recursivePath(obj, arr, locales, key) {
    arr.shift();
    if (arr.length > 0) {
      obj[arr[0]] = obj[arr[0]] !== undefined ? obj[arr[0]] : {};
      recursivePath(obj[arr[0]], arr, locales, key);
    } else {
      return;
    }
  }
  
  const nestedVal = {
    get(path, root) {
      return path.split('.').reduce((p, c) => p[c], root);
    },
    set(path, root, val) {
      path = path.split('.');
      const key = path.pop();
      nestedVal.get(path.join('.'), root)[key] = val;
    }
  };

export default createI18n({
    legacy: false,
    locale: sendData.lang,
    messages: loadLocaleMessages()
})